import React, { useEffect } from 'react';

function usePortal() {
  const rootElemRef = React.useRef(document.createElement('div'));

  useEffect(() => {
    document.body.appendChild(rootElemRef.current);

    const element = rootElemRef.current;
    return function removeElement() {
      element.remove();
    };
  }, []);

  return rootElemRef.current;
}

export default usePortal;
